import { render, staticRenderFns } from "./PublicNotifications.vue?vue&type=template&id=9fe34720&scoped=true"
import script from "./PublicNotifications.vue?vue&type=script&lang=js"
export * from "./PublicNotifications.vue?vue&type=script&lang=js"
import style0 from "./PublicNotifications.vue?vue&type=style&index=0&id=9fe34720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe34720",
  null
  
)

export default component.exports